import DetailsHeader from 'app-sections/common/applications/details/components/details-header/DetailsHeader';
import { Outlet } from 'react-router-dom';

export default function ApplicationDetailsLayout() {
  return (
    <>
      <DetailsHeader />
      {/* <CustomRoutesProvider mobileAnimationType="opacity" /> */}
      <Outlet />
    </>
  );
}
